import { useSelector } from "react-redux";
import SavedLists from "../../../presentational/common/SavedLists";
import {
  getDisplayableItemCount,
  getSavedItemsSdkFailure
} from "../../../../state/selectors";
import SdkError from "../../../presentational/common/PageLoadError/sdkError";

const SavedItemsContainer = props => {
  const initialisationFailure = useSelector(getSavedItemsSdkFailure);
  const itemCount = useSelector(getDisplayableItemCount);

  return (
    <SavedLists
      {...{
        ...props,
        itemCount,
        initialisationFailure
      }}
    >
      <SdkError />
    </SavedLists>
  );
};

export default SavedItemsContainer;
